import { useOnboardingContext, useTourContext } from "@/contexts";
import { useScopedHref } from "@/hooks";
import { OnboardingBanner as LibOnboardingBanner } from "@/ui";

export type OnboardingBannerProps = {
  className?: string;
};

export const OnboardingBanner = ({ className }: OnboardingBannerProps) => {
  const { onboarding, loading } = useOnboardingContext();
  const { ids } = useTourContext();
  const scopedHref = useScopedHref();

  const allStepsCompleted =
    !!onboarding &&
    onboarding.steps.length > 0 &&
    onboarding.steps.every((step) => step.isCompleted);

  if (!loading && allStepsCompleted) {
    return null;
  }

  return (
    <LibOnboardingBanner
      id={ids.onboarding}
      href={scopedHref("/onboarding")}
      isLoading={loading}
      className={className}
    />
  );
};
